
export default [
  {
    name: `instruction_1`,
    title: `Slide your finger to explore in 360°.`,
  },
];
